<template>
  <v-container fluid>
      <div class='font-weight-bold'>Your local may have more than one option available to you for paying your dues. Please work with your local to determine your payment method.</div>
  </v-container>
</template>

<script>
  //import axios from 'axios'
  export default {
    name: 'LblCashCheck',
    data:() => ({    
        
    }),
    methods:{        
    },
    mounted:function(){

    },
    watch:{        
    }
  }
</script>

<style scoped>

</style>